import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Text } from "../../../text";
import { Image, Label, SignatureContainer } from "./styles";
import { Button } from "../../../button";
import { getPreSignedUrl } from "../../formHelpers";
/** Show signature image in places where you just want it to be displayed, not edited.  */
const RENDER_DELAY_MS = 1000;
export const SignatureAsImage = ({ url, transformUrl, label, hasSignature, errorButtonText, onErrorButtonClick, }) => {
    const [canLoadImage, setCanLoadImage] = useState(true);
    /** There is an edge case: User gets to the last slide. He wants to change his signature, checks "Show only incomplete and flagged slides" checkbox than clicks on "If needed, please click here to update signature on 'Let's Get Started' slide." He changes his signature and only page he has left when he clicks accept button is the last slide. Problem is that he gets there faster than new signature is saved so the error is thrown. We set this delay to create a time gap that is unnoticable. Just in case user has really slow connection and the error appears, we set the message prompting him to reload the page and retry. */
    const [delayRender, setDelayRender] = useState(true);
    const [preSignedUrl, setPreSignedUrl] = useState(null);
    useEffect(() => {
        const fetchFileDetails = async (url) => {
            try {
                const preSignedUrl = await getPreSignedUrl(url, transformUrl);
                setPreSignedUrl(preSignedUrl);
            }
            catch {
                // Silently handle file fetch errors - component handles missing images gracefully
            }
        };
        if (url) {
            fetchFileDetails(url);
        }
        const timer = setTimeout(() => {
            setDelayRender(false);
        }, RENDER_DELAY_MS);
        return () => clearTimeout(timer);
    }, []);
    return (_jsxs(SignatureContainer, { disabled: true, style: { textAlign: "center" }, children: [_jsx(Label, { "data-test-id": "residentSignatureLabel", children: label }), !delayRender && (_jsxs(_Fragment, { children: [_jsx(Image, { "data-test-id": "residentSignature", src: preSignedUrl, style: { display: canLoadImage ? "block" : "none" }, alt: label, onError: () => {
                            setCanLoadImage(false);
                        } }), hasSignature ? (_jsx(Text, { fontSize: 20, style: {
                            display: canLoadImage ? "none" : "block",
                            margin: "auto",
                            marginTop: "20px",
                            marginBottom: "40px",
                        }, children: "Unable to load signature. Try to reload the page." })) : (_jsx(Button, { style: {
                            display: "block",
                            margin: "auto",
                            marginTop: "20px",
                            marginBottom: "40px",
                        }, outline: true, color: "primary", onClick: () => onErrorButtonClick(), children: errorButtonText }))] }))] }));
};
